import React, { useContext, useEffect, useState } from "react";
import "./Chats.css";
import Header from "../Header/Header";
import { getAllChats, getAllData, sendMessageApi } from "../../../utils/apis/Chat/Chat";
import { Context } from "../../../utils/context";



const Chats = () => {
  const [selectedUser, setSelectedUser] = useState();
  const [message, setMessage] = useState("");

  const { shimmerLoader, setShimmerLoader } = useContext(Context);

  const sendMessage = async () => {
    if (!message.trim() || !selectedUser) return;
    const res = await sendMessageApi(selectedUser?.id, { message });
    if (res?.success) {
      getChats();
      setMessage("");
    }

  };


  const [data, setData] = useState([]);
  const [chats, setChats] = useState([]);
  const getData = async () => {
    setShimmerLoader(true);
    const res = await getAllData();
    if (res?.success) {
      setData(res?.data);

      setShimmerLoader(false);
    }

  };

  const getChats = async () => {
    setShimmerLoader(true);
    if (selectedUser) {
      const res = await getAllChats(selectedUser?.id);
      if (res?.success) {
        setChats(res?.data);

        setShimmerLoader(false);
      }
    } else {
      setChats([]);
      setShimmerLoader(false);
    }
  };


  useEffect(() => {
    getData(); // initial call

    // const interval = setInterval(() => {
    //   getData();
    // }, 10000); // 30 seconds

    // return () => clearInterval(interval); // cleanup
  }, []);

  useEffect(() => {
    getChats();
  }, [selectedUser]);

  const getInitials = (name = "") =>
    name
      .split(" ")
      .filter(Boolean)
      .map(word => word[0].toUpperCase())
      .join("");

  return (
    <>
    {shimmerLoader ? (
      <> 

    </>) : (
      <>
    <div className="main-advancedashboard">
        <Header title="Chats" link="/chats" />

        <div className="chat-container">
          {/* LEFT SIDEBAR */}
          <div className="chat-users">
            <h4>Users</h4>
            {data?.map((u) => (
              <div
                key={u?.id}
                className={`user-item ${selectedUser?.id === u?.id ? "active" : !u?.last_user_read_status ? "unread" : ""}`}
                onClick={() => setSelectedUser(u)}
              >
                <div className="avatar">{u?.user.f_name?.[0]}{u?.user.l_name?.[0]}</div>
                <div>
                  <p className="username">{u?.user.f_name} {u?.user.l_name}</p>
                  <small className="last-message">{u?.last_message}</small>
                </div>
              </div>
            ))}
          </div>

          {/* CHAT AREA */}
          <div className="chat-box">
            {/* TOP BAR */}
            <div className="chat-header">
              {selectedUser && (<h4>{selectedUser?.user.f_name} ({selectedUser?.user.contact_no})</h4>)}
              <button
                className="refresh-btn"
                onClick={() => window.location.reload()}
              >
                🔄 Refresh
              </button>
            </div>

            {/* MESSAGES */}
            <div className="chat-messages">
              {chats?.map((msg, idx) => (
                <div
                  key={idx}
                  className={`message-row ${msg.position === "right" ? "right" : "left"}`}
                >
                  {/* Avatar */}
                  <div className="avatar">
                    {getInitials(msg.sender_name)}
                  </div>

                  {/* Message bubble */}
                  <div className="message">
                    {msg.message}
                  </div>
                </div>
              ))}
            </div>


            {/* INPUT */}
            <div className="chat-input">
              <input
                type="text"
                placeholder="Type a message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              />
              <button onClick={sendMessage}>Send</button>
            </div>
          </div>
        </div>
      </div>
     </>)}
      
    </>

  );
};

export default Chats;
